import { useState, useEffect } from 'react';
import { Box, Flex, Text, Button, Heading, Grid, Card, Avatar, Separator } from '@radix-ui/themes';
import { useSelector } from 'react-redux';
import SchoolStaff from '../school/SchoolStaff';
import SchoolReportSummary from '../school/SchoolReportSummary';
import UserAvatar from '../common/UserAvatar';
import StatsCard from '../common/StatsCard';
import { PersonIcon, CheckCircledIcon, ClockIcon, CheckIcon, ChevronRightIcon, StackIcon } from '@radix-ui/react-icons';
import { schoolService } from '../../services/school/schoolServices';
import SchoolTeacherSummaryView from '../school/SchoolTeacherSummaryView';
import MessageBox from '../common/MessageBox';
import { useNavigate } from 'react-router-dom';
const SchoolDashboard = () => {
  const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL
  const schoolAdmin = useSelector((state) => state.schoolAdmin);
  const user = useSelector((state) => state.user.details);
  const [stats, setStats] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    fetchStats();
  }, []);

  // const calculateMetrics = (metricsData) => {
  //   let metrics = [];
  //   metricsData.forEach((metric) => {
  //     const adherence = metric.performance_metrics.filter((m) => m.type === 'schedule_adherence');
  //     const questions = metric.performance_metrics.filter((m) => m.type === 'questions_confirmed');
  //     metrics.push({
  //       teacher: {id: metric.id, status: metric.status, verification_status: metric.verification_status},
  //       user: metric.user,
  //       adherence,
  //       adherence_avg: adherence.reduce((acc, curr) => acc + (curr.value ? curr.value : 0), 0) / adherence.length,
  //       questions,
  //       questions_avg: questions.reduce((acc, curr) => acc + (curr.value ? curr.value : 0), 0) / questions.length,
  //     })
  //   });
  //   setTeacherMetrics(metrics);
  // }

  const fetchStats = async () => {
    try {
      const response = await schoolService.getSchoolSummary(schoolAdmin.school.id);
      // console.log('response~~~~~~~~~~~~~~~~~', response);
      setStats(response);
      // calculateMetrics(response.teachers);
    } catch (error) {
      console.error('Error fetching school stats:', error);
    }
  };

  const renderMetrics = (metrics) => {
    return metrics.map((metric) => (
      <Flex direction="row" justify="between" gap="4">
        <Text size="1" as="p">{metric.type}</Text>
        <Text size="1" as="p">{metric.value}</Text>
      </Flex>
    ));
  }

  return (
    <Box width="100%" maxWidth="1080px">
      <Grid columns="12" gap="4">
        <Box gridColumnStart="1" gridColumnEnd={{ initial: 13, sm: 7 }}>
          <Flex direction="row" justify={"between"} align="center" gap="4">
            <Avatar size="6"
              src={`${PUBLIC_URL}/storage/${schoolAdmin.school.crest}`}
              radius='large'
              fallback={<Avatar
                size="6"
                src={'/images/defaultCrest.png'}
                radius='large'
              />}
            />
            <Flex direction="column" gap="2">
              <Text size="2" weight="bold" align="right" as="p">{schoolAdmin.school.name}</Text>
              <Text size="2" color="gray" align="right" as="p">{schoolAdmin.school.location}</Text>
              <Flex justify="start" align="center" gap="2">
                <CheckIcon color='green' width="16px" height="16px" /><Text size="2" color="gray" as="p">Verified by DEXT</Text>
              </Flex>
            </Flex>
          </Flex>
          <Separator size="4" my="4" />
          <Flex direction="row" gap="4" justify="end" align="center" width="100%">
            <UserAvatar size="3" user={user} radius='large' />
            <Box>
              <Text size="1" color="gray" as="p">Registered by</Text>
              <Text size="2" weight="bold" as="p">{user.firstname} {user.lastname}</Text>
            </Box>
          </Flex>
        </Box>
        <Flex direction="column" gap="4" gridColumnStart={{ initial: 1, sm: 7 }} gridColumnEnd={{ initial: 13, sm: 13 }}>
          <Flex direction="row" justify="between" gap="4">
            <StatsCard
              title="Teachers"
              value={stats.total_teachers}
              icon={<PersonIcon width="20" height="20" />}
              color="blue"
              style={{
                flex: 1,
                backgroundColor: 'var(--blue-a2)'
              }}
              className="custom-stats-card"
              onClick={() => {
                navigate('/school/teachers');
              }}
            />
            <StatsCard
              title="Students"
              value={stats.total_students}
              icon={<ClockIcon width="20" height="20" />}
              color="green"
              // trend={{ value: 12, direction: 'up' }}
              style={{
                flex: 1
              }}
            />
          </Flex>
          <Flex direction="row" justify="between" gap="4">
            <StatsCard
              title="Courses"
              value={stats.total_courses}
              icon={<StackIcon width="20" height="20" />}
              color="purple"
              style={{
                flex: 1
              }}
            />
            <StatsCard
              title="Requests"
              value={stats.total_verifications}
              icon={<CheckCircledIcon width="20" height="20" />}
              color="amber"
              style={{
                flex: 1
              }}
              onClick={() => {
                navigate('/school/verifications');
              }}
            />
          </Flex>
        </Flex>
        <Box gridColumnStart={{ initial: 1, sm: 1 }} gridColumnEnd={{ initial: 13, sm: 7 }} mt="4">
          {stats?.teachers?.length == 0 && (
            <Box>
              {/* <Card>
                <Text size="1" as="p" weight="bold">No teachers found</Text>
                <Text size="1" as="p">Inform your teachers visit edusua.com and register and search for your school as it appears on your dashboard. If they are already registered, they can apply to your school for verification from their profile page</Text>
              </Card> */}
              <MessageBox type="info" title="No teachers found"
                message="Inform your teachers visit edusua.com and register and search for your school as it appears on your dashboard. If they are already registered, they can apply to your school for verification from their profile page"
                options={{ extraText: "If you are a teacher, please contact your school admin to add you to the school" }}
              />
            </Box>
          )}

          <Flex direction="column" gap="4">
            {stats?.teachers?.length > 0 && <SchoolTeacherSummaryView teachers={stats.teachers} />}
          </Flex>
        </Box>
      </Grid>
    </Box>
  )
};

export default SchoolDashboard;
